import Environment from '../../lib/Environment';
import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { v4 as uuidv4 } from 'uuid';

export interface ILanguageFile {
  name: string;
  file: string;
}

export interface ILanguages {
  [key: string]: ILanguageFile;
}

export class LanguageSystem {
  private readonly base = '/traduccion/user';

  private languages: ILanguages = {}

  constructor(private requestHandler: XhrRequestHandler, private environment: Environment) { }
  
  async updatedUserLanguage(trad_nombre: string, userId: string) {
    const headers = { idTransaccion: uuidv4(), msgTransaccion: 'Actualizacion de idioma del usuario' };
    return await this.requestHandler.put(`${this.base}/${userId}`, { trad_nombre }, headers);
  }
  
  getLanguages() {
    return this.languages;
  }

  async findLanguages(): Promise<{ languages: ILanguages }> {
    if (Object.keys(this.languages).length > 0) {
      return { languages: this.languages };
    } 
    const url = this.environment.translationUrl();
    return this.requestHandler.get<{ languages: ILanguages }>(url);
  }

  async getLanguageFile(trad_nombre: string) {
    if (this.languages[trad_nombre]) {
      return this.languages[trad_nombre].file
    }
  }

  setLanguages(languages: ILanguages) { 
    this.languages = languages;
  }

  getLanguage(trad_nombre: string) {
    return this.languages[trad_nombre];
  }
}
